import { useRef } from 'react';
import packageJson from '../../package.json';
import useEnv from './useEnv';

// Set the name of the hidden property and the change event for visibility
let visibilityChange = '';
if (document.hidden !== undefined) { // Opera 12.10 and Firefox 18 and later support
    visibilityChange = 'visibilitychange';
} else if (document.msHidden !== undefined) {
    visibilityChange = 'msvisibilitychange';
} else if (document.webkitHidden !== undefined) {
    visibilityChange = 'webkitvisibilitychange';
}

const MAX_CHECK_INTERVAL = 60000; // 1 minute

const useReloader = (confirmText) => {
    const { isProduction } = useEnv();
    const timeoutRef = useRef(null);
    const lastCheckTimeRef = useRef(0);

    const reload = () => {
        if (caches !== undefined) {
            // Service worker cache should be cleared with caches.delete()
            caches.keys().then(names => {
                for (const name of names) {
                    caches.delete(name);
                }
            });
        }
        // delete browser cache and hard reload
        window.location.reload(true);
    }

    const handleVisibilityChange = () => {
        if (!document.hasFocus()) {
            return;
        }
        // Debounce multiple calls
        if (timeoutRef.current !== null) {
            window.clearInterval(timeoutRef.current);
        }
        timeoutRef.current = window.setTimeout(onFocus, 500);
    }

    const onFocus = () => {
        if ((Date.now() - lastCheckTimeRef.current) < MAX_CHECK_INTERVAL) {
            return;
        }
        fetch(`/meta.json?t=${Date.now()}`)
            .then(response => response.json())
            .then(meta => {
                const latestVersion = meta.version;
                if (latestVersion !== undefined && latestVersion.toString() !== packageJson.version.toString()){
                    lastCheckTimeRef.current = Date.now();
                    if (window.confirm(confirmText)) {
                        reload();
                    }
                }
            }).catch(error => {
                if (!isProduction) {
                    console.error('Error fetching meta.json:', error);
                }
            })
    }

    const initReloadListeners = () => {
        if (!isProduction) {
            console.log('Reloader not used in dev or testing');
            return;
        }
        if (document.addEventListener !== undefined) {
            document.addEventListener(visibilityChange, handleVisibilityChange, false);
        }
        window.addEventListener("focus", handleVisibilityChange, false);
        window.addEventListener("pageshow", handleVisibilityChange, false); // For iOS
        return () => {
            document.removeEventListener(visibilityChange, handleVisibilityChange);
            window.removeEventListener("focus", handleVisibilityChange);
            window.removeEventListener("pageshow", handleVisibilityChange);
        }
    }

    return {
        initReloadListeners
    }
}

export default useReloader;
